
import { defineComponent, PropType } from "vue";
import { AudioDetail } from "../hooks/useAudioPlay";

export default defineComponent({
  props: {
    audioDetail: {
      type: Object as PropType<AudioDetail>,
      required: true,
    },
  },
});
